var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Vector2dSchema } from "./utils/vector.js";
import { Component, Schema, type, nullable, defaultValue } from "./decorators/type.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let ChildSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "parent");
    __publicField(this, "autoAttach");
    __publicField(this, "post");
    __publicField(this, "direction");
    __publicField(this, "offset");
  }
};
__decorateClass([
  type("Entity"),
  nullable()
], ChildSchema.prototype, "parent", 2);
__decorateClass([
  type("boolean"),
  defaultValue(true)
], ChildSchema.prototype, "autoAttach", 2);
__decorateClass([
  type("boolean"),
  defaultValue(true)
], ChildSchema.prototype, "post", 2);
__decorateClass([
  type("boolean"),
  defaultValue(true)
], ChildSchema.prototype, "direction", 2);
__decorateClass([
  type(Vector2dSchema)
], ChildSchema.prototype, "offset", 2);
ChildSchema = __decorateClass([
  Component("Child")
], ChildSchema);
const __vite_glob_0_12 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ChildSchema() {
    return ChildSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  ChildSchema as C,
  __vite_glob_0_12 as _
};
//# sourceMappingURL=Child-888ef1d8.js.map
